export function submissionRecordLink(taskId: number | undefined, assignmentId: number) {
  const params = new URLSearchParams();
  if (taskId !== undefined) params.set("task_id", String(taskId));
  params.set("assignment_id", String(assignmentId));
  return `/submissions?${params}`;
}
